<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="main">
      <navMenu ></navMenu>
      <div class="content" >
        <div class="go-back" @click="goback" style="margin-bottom: 20px">返回</div>
        <div class="header_main">
          <div class="header_title">{{ itemdata.name }}（适用于品牌方和工厂企业）</div>
        </div>
        <div class="content_main">
          <div class="content_title" v-if="itemdata.id==1">
            <p style="color: red">* 报名须知：</p>
            <p>
              1. 须为2022年以后上市的产品
            </p>
            <p>
              2. 每个参展企业可免费报名一款产品，增加产品1500元/款，如有需求请联系您的参展顾问。
            </p>
            <p>
              3. 工厂企业可上架自有品牌终端产品，也可推荐品牌企业客户产品
            </p>
            <p>
              4. 非展商报名或额外增加产品，均收费3000元/款
            </p>
            <p>报名表回传后视为同意主办方使用相关资料（个人联系方式和标注不对外公布的除外）用于活动的宣传推广和现场展示</p>

            <p>报名截止时间2024年10月18日</p>
            <p class="tipsa">
              注意：“货架好物”活动报名成后，请邮寄样品10份用于现场展示（请发空包装产品，实物产品主办方将统一处理不再寄回）。快递外包装清注明<br>“NHNE未来营养超市+公司名称+产品名称”邮寄地址（2024年11月1日前发出快递）：北京市朝阳区新源南路1-3号平安国际金融中心B座15层，魏琳青，18810390013
                        </p>
          </div>
          <div class="content_title" v-if="itemdata.id==2">
          <p style="color: red">* 报名须知：</p>
          <p>
            1. 为保证现场秩序和活动效果，每场对接会每家企业限2人，凭票进场
          </p>
          <p>
            2. 报名截止时间2024年11月15日
          </p>
          <p>
            3. 对接会安排仅供参考，场次及时间确认后将通知报名企业确认，如有调整以现场为准
          </p>
          <br />
          <p style="color: red">* 特别说明：</p>
          <p style="color: red">为保证您的对接效果，对接私域渠道、主播达人、社群团长，请务必确认以下几点：</p>
          <p style="color: red">1. 可做一件代发供货模式</p>
          <p style="color: red">2. 相对灵活的定价机制和佣金空间</p>
          <p style="color: red">3. 取得品牌在特定私域渠道销售产品的授权</p>
          <p style="color: red">4. 提前准备对接素材，如店铺链接（快团团/群接龙等），选品笔记，产品手册等</p>
        </div>
          <div class="content_title" v-if="itemdata.id==3">
            <p style="color: red">* 报名须知：</p>
            <p>
              1. 报名表回传后视为同意主办方使用相关资料（个人联系方式和标注不对外公布的除外）用于活动的宣传推广和现场展示
            </p>
            <p>
              2. 报名截止时间2024年10月18日
            </p>

          </div>
          <div class="btn_box">
            <span
              class="tb_btn"
              :class="{ end: isDisabled }"
              :disabled="isDisabled"
              @click="synproduct"
              >同步产品信息</span
            >
            <span class="xj_btn" @click="tapForm('add')">新建产品</span>
            <span class="tips" v-if="itemdata.name == '货架好物报名'"
              >已提交/可提交（{{ count }} / {{ goods_num }}）</span
            >
          </div>
          <div class="cp_list" v-if="list.length>0">
            <div
              class="cp_item"
              :class="{ cp_green: item.enrollment_status == 1 }"
              v-for="(item, index) in list"
              :key="index"
            >
              <img
                class="cp_item_img"
                v-if="item.imgs"
                :src="$imgOssUrl + item.imgs"
              />
              <img
                class="cp_item_img"
                v-else
                src="../../assets/discussion/zwtp.jpg"
              />
              <div class="txt_content">
                <div class="cp_item_top">
                  <span>{{ item.goodsName }}</span>
                  <span class="tj wtj" v-if="item.awards_status == 'uncommitted'"
                    >未报名</span
                  >
                  <span class="tj ytj" v-if="  item.awards_status == 'submitted'"
                    >已报名</span
                  >
                </div>
                <div class="cp_item_bottom">
                  <span>{{ item.introduction }}</span>
                  <!--<img src="./images/discussion_edit.jpg" @click="tapForm('edit',item.id)">-->
                </div>
              </div>
              <template>
                <div class="footer_btn">
                  <div class="cypx end" v-if="timestatus == 0">评选未开始</div>
                  <div class="cypx end" v-if="timestatus == 1">评选已结束</div>
                  <div
                    class="cypx"
                    @click="tapForm('edit', item.id, item.market_time_status)"
                    v-if="
                      item.awards_status == 'uncommitted' &&
                      count !== goods_num &&
                      timestatus == 2
                    "
                  >
                    立即报名
                  </div>
                  <div
                    class="cypx"
                    v-if="item.awards_status == 'submitted'"
                    @click="openModal(item)"
                  >
                    生成海报
                  </div>
                  <div
                    class="cypx"
                    @click="tapForm('edit', item.id, item.market_time_status)"
                    v-if="item.awards_status == 'submitted' && timestatus == 2"
                  >
                    编辑报名
                  </div>
                  <div
                          class="cypx"
                          @click="getdetail(1, item.id)"

                  >
                    产品详情
                  </div>
                  <!-- <div class="cypx" @click="getdetail(1)">产品详情</div>
                                <div class="cypx" @click="getdetail(2)">评奖详情</div>
                                <div class="cypx" style="background: #f56c6c;" @click="del(item.id)">删除</div> -->
                </div>
              </template>
              <!--<template>-->
                <!--<div class="cp_operate">-->
                  <!--<img-->
                    <!--class="cp_icon"-->
                    <!--src="../../assets/discussion/dis_icon01.jpg"-->
                  <!--/>-->
                  <!--<div-->
                    <!--class="cp_edit"-->
                    <!--:style="-->
                      <!--item.awards_status == 'submitted'-->
                        <!--? 'height:86px'-->
                        <!--: 'height: 56px'-->
                    <!--"-->
                  <!--&gt;-->
                    <!--<div class="edit-text" @click="getdetail(1, item.id)">-->
                      <!--产品详情-->
                    <!--</div>-->
                    <!--<div-->
                      <!--class="edit-text"-->
                      <!--@click="getdetail(2, item.id)"-->
                      <!--v-if="item.awards_status == 'submitted'"-->
                    <!--&gt;-->
                      <!--评选详情-->
                    <!--</div>-->
                    <!--&lt;!&ndash; <div class="edit-text" @click="del(item.id)">删除</div> &ndash;&gt;-->
                    <!--&lt;!&ndash; <div class="edit-text" style="border-top: 1px solid #EEE;" @click="cancle(item.id)">撤销</div>-->
	                                   <!--<div class="edit-text" style="border-top: 1px solid #EEE;" @click="showAddress">地址</div> &ndash;&gt;-->
                  <!--</div>-->
                <!--</div>-->
              <!--</template>-->
            </div>
          </div>
          <nodata v-else></nodata>
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page_no"
            :page-size="page_size"
            layout=" prev, pager, next, total"
            :total="total"
          >
          </el-pagination>
        </div>
        <div class="address-wrap" v-if="isShowAddress" @click="hideAddress">
          <div class="address-main">
            <div class="address-tips">
              注意：请同步邮寄相应产品三份至主办方处，并注明物品信息。<br />*
              样品仅作为参选材料真实性查验及现场评选之依据，请务必确保参评产品无安全风险
            </div>
            <div class="adress_box">
              <div>邮寄地址：</div>
              <el-input
                readonly
                v-model="address"
                class="adress_input"
                ref="inputElement"
              ></el-input>
              <div class="fz_btn" @click.stop="copyToClipboard">复制</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 弹出窗口 -->
      <div v-if="showModal" class="modal">
        <div class="modal-content">
          <canvas ref="posterCanvas" width="356" height="633"></canvas>
          <div>
            <el-button @click="closeModal">关闭</el-button>
            <el-button type="primary" @click="generatePoster"
              >下载海报</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  nhneProductlists,
  delNhneMarketProduct,
  nhneCompanydetail,
  getEnrollCount,
  marketNhneDict,
  synProductByOM,
  upBase64cCode,
  savePoster
} from "@/api/api";
import "../../style/base.css";
import top from "../../components/top.vue"; //头部
import navMenu from "../../components/navMenu.vue"; //左侧步骤条
import nodata from "../../components/nodata"; //头部
export default {
  name: "productawardList",
  components: { top, navMenu,nodata },
  data() {
    return {
      Imghttp: "https://oss.larspring.com/pharmchina",
      address:
        "北京市朝阳区新源南路1-3号平安国际金融中心B座15层，田先生 18611347915",
      list: [],
      award_id: "", // 奖项id
      is_report: "",
      page_no: 1,
      page_size: 8,
      total: 0, // 总条目数，需要根据实际情况设置
      isShowAddress: false, //邮寄地址弹框
      timestatus: "",
      goods_num: "",
      itemdata: {},
      count: "", // 评奖数量
      isDisabled: false,
      showModal: false,
      hallNo: "",
      backgroundImage1: require("@/assets/discussion/image_bg1.jpg"),

      backgroundImage2: require("@/assets/discussion/image_bg2.jpg"), // 背景图片 URL
        id:''
    };
  },
  mounted() {
    console.log(this.$route.query.item, "this.$route.query.item");
    //获取url上的参数
    //  this.item = this.$route.query.id;
    //  this.is_report = this.getQueryString('report');
    this.itemdata = JSON.parse(sessionStorage.getItem("itemdata"));
    this.getmarketNhneDict();
    this.getnhneCompanydetail();
    this.getList();
    this.getEnrollCount();
  },
  methods: {
      goback(){
          this.$router.back()
      },
    openModal(item) {
      this.showModal = true;
      this.$nextTick(() => {
        this.drawPoster(item); // 确保 DOM 更新后再绘制
      });
    },
    closeModal() {
      this.showModal = false;
    },
    drawPoster(item) {
      this.id=item.id;
      const canvas = this.$refs.posterCanvas;
      if (!canvas) {
        console.error("Canvas 元素未找到");
        return;
      }

      const ctx = canvas.getContext("2d");

      // 清空画布
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // 绘制背景图
      const backgroundImg = new Image();
      backgroundImg.crossOrigin = "Anonymous"; // 处理跨域问题

      const overlayImgSrc = `${this.$imgOssUrl + item.imgs}`;

      backgroundImg.onload = () => {

        ctx.drawImage(backgroundImg, 0, 0, canvas.width, canvas.height);

        const overlayImg = new Image();
        overlayImg.crossOrigin = "Anonymous"; // 设置跨域属性
        overlayImg.src = overlayImgSrc;


          overlayImg.onload = () => {
              const width = 180; // 前景图的宽度
              const height = 180; // 前景图的高度
              const x = (canvas.width - width) / 2; // x 轴居中
              const y = 211; // 距离顶部 211 像素

              ctx.drawImage(overlayImg, x, y, width, height);
              // 使用 setTimeout 来确保绘制完成后获取数据 URL

              try {
                  const dataURL = canvas.toDataURL("image/png"); // 生成图像数据 URL
                  console.log("Data URL:", dataURL);

              } catch (error) {
                  console.error("Failed to get data URL:", error);
              }


             };




        overlayImg.onerror = (error) => {
          console.error("前景图加载失败", error);
            console.log(overlayImg.src,"overlayImg2")
        };


        // 绘制公司名
        let up_suggest = item.up_suggest.split(",")[0];
        if (up_suggest !== "") {
          // 设置产品货架
          ctx.font = "500 22px Arial";
          ctx.fillStyle = "#fff";
          ctx.textAlign = "center";

          ctx.fillText(up_suggest + "产品货架", canvas.width / 2, 170 + 22 / 2);
        }

        // 绘制公司名
        if (item.companyName !== "") {
          // 设置公司名文本样式
          ctx.font = "500 16px Arial";
          ctx.fillStyle = "#000";
          ctx.textAlign = "center";

          ctx.fillText(item.companyName, canvas.width / 2, 450 + 16 / 2);
        }

        // 绘制产品名
        if (item.goodsName !== "") {
          // 设置产品名文本样式
          ctx.font = "500 20px Arial"; // 修改字号大小
          ctx.fillStyle = "#000"; // 修改字号颜色
          ctx.textAlign = "center";
          ctx.fillText(item.goodsName, canvas.width / 2, 410 + 20 / 2); // 修改字号位置
        }

        // 绘制展位号
        const hallNo = this.hallNo;
        if (hallNo !== "") {
          const fontSize = 16;
          const textWidth = 150; // 固定宽度
          const textHeight = 28; // 固定高度
          const lineHeight = 28; // 行高
          const distanceFromBottom = 145; // 距离底部的距离
          const yPosition = canvas.height - distanceFromBottom; // 产品名矩形的纵坐标

          // 绘制背景矩形
          ctx.fillStyle = "#F60009"; // 背景色
          ctx.beginPath();
          ctx.moveTo(
            canvas.width / 2 - textWidth / 2,
            yPosition - textHeight / 2
          );
          ctx.arcTo(
            canvas.width / 2 + textWidth / 2,
            yPosition - textHeight / 2,
            canvas.width / 2 + textWidth / 2,
            yPosition + textHeight / 2,
            14
          ); // 圆角半径14
          ctx.arcTo(
            canvas.width / 2 + textWidth / 2,
            yPosition + textHeight / 2,
            canvas.width / 2 - textWidth / 2,
            yPosition + textHeight / 2,
            14
          );
          ctx.arcTo(
            canvas.width / 2 - textWidth / 2,
            yPosition + textHeight / 2,
            canvas.width / 2 - textWidth / 2,
            yPosition - textHeight / 2,
            14
          );
          ctx.arcTo(
            canvas.width / 2 - textWidth / 2,
            yPosition - textHeight / 2,
            canvas.width / 2 + textWidth / 2,
            yPosition - textHeight / 2,
            14
          );
          ctx.closePath();
          ctx.fill();

          // 绘制展位号
          ctx.font = `500 ${fontSize}px Arial`;
          ctx.fillStyle = "#fff"; // 文本颜色
          ctx.textAlign = "center";

          // 计算文本行数
          const lines = hallNo.split("\n");
          lines.forEach((line, index) => {
            ctx.fillText(
              "展位号:" + hallNo,
              canvas.width / 2,
              yPosition +
                (index - (lines.length - 1) / 2) * lineHeight +
                fontSize / 2
            ); // 调整位置
          });
        }
      };
      backgroundImg.src = this.itemdata.name == "货架好物报名" ? this.backgroundImage2 : this.backgroundImage1;
      backgroundImg.onerror = () => {
        console.error("背景图片加载失败");
      };
    },

    generatePoster() {
      const canvas = this.$refs.posterCanvas;
      if (!canvas) {
        console.error("Canvas 元素未找到");
        return;
      }
      const dataURL = canvas.toDataURL("image/png");
        this.getupBase64cCode(dataURL)
      console.log(dataURL, "dataURL");

      // 生成海报后可以做进一步处理，例如下载或发送到服务器
      const link = document.createElement("a");
      link.href = dataURL;
      link.download = "poster.png";
      link.click();
    },
      getupBase64cCode(dataURL){
        let data={base64_image:dataURL}
          upBase64cCode(this.$qs.stringify(data)).then(res=>{
              if(res.data.code==1){
                  console.log("保存成功")
                  this.getsavePoster(res.data.data.url)
              }else{
                  this.$message.error((res.data.msg))
              }

          }).catch(error=>{
              console.log(error)
          })
      },
      getsavePoster(url){
          let data={id:this.id,awards_id:this.itemdata.id,poster:url}
          savePoster(data).then(res=>{
              if(res.data.code==1){
                  console.log("保存成功")
              }else{
                  this.$message.error((res.data.msg))
              }

          }).catch(error=>{
              console.log(error)
          })
      },
    // 同步产品信息
    synproduct() {
      if (this.isDisabled) return; // 如果按钮被禁用，则不处理点击事件
      // 禁用按钮
      this.isDisabled = true;
      synProductByOM({})
        .then((res) => {
          if (res.data.code == 1) {
            this.$message.success(res.data.msg);
            this.getList();
          } else {
            this.$message.warning(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });

      // 1 分钟后启用按钮
      setTimeout(() => {
        this.isDisabled = false;
      }, 60000); // 60000 毫秒 = 1 分钟
      // axios.post('api.php?m=nhneProduct.synProductList&v=3.0',{}).then(res => {
      //     //console.log(res, '---获取详情');
      //     if(res.data.errno == 0){
      //         this.$message.success("同步成功！")
      //         this.getList()
      //     }else{
      //         this.$message.warning(res.data.errmsg)
      //         this.getList()
      //     }
      //
      // })
      //     .catch(function (err) {
      //         console.log(err);
      //     });
    },
    // 获取评奖表单字典数据
    getmarketNhneDict() {
      marketNhneDict({})
        .then((res) => {
          if (res.data.code == 1) {
            let dictData = res.data.data;
            sessionStorage.setItem("dictData", JSON.stringify(dictData));
            // 直接从响应中提取数据
            const { productClass } = res.data.data;
            if (productClass) {
              // 处理 productClass 的转换
              let productClassnew = Object.entries(productClass).map(
                ([key, items]) => ({
                  label: key,
                  value: key,
                  children: items.map((item) => ({
                    label: item,
                    value: item,
                  })),
                })
              );
              sessionStorage.setItem(
                "productClass",
                JSON.stringify(productClassnew)
              );
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // 获取评奖表单企业详情
    getnhneCompanydetail() {
      nhneCompanydetail({})
        .then((res) => {
          console.log(res, "res");
          if (res.data.code == 1) {
            this.goods_num = res.data.data.goods_num;
            this.hallNo = res.data.data.hallNo;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //删除产品
    del(id) {
      this.$confirm("确定要删除该条产品数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.delproduct(id);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    delproduct(id) {
      delNhneMarketProduct({ id: id })
        .then((res) => {
          if (res.data.code == 1) {
            this.getList();
            this.$message({
              type: "success",
              message: res.data.msg,
            });
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //    // 同步产品信息
    //    synproduct(){
    //       axios.post('api.php?m=nhneProduct.synProductList&v=3.0',{}).then(res => {
    //            //console.log(res, '---获取详情');
    //            if(res.data.errno == 0){
    //                 this.$message.success("同步成功！")
    //                 this.getList()
    //            }else{
    //                 this.$message.warning(res.data.errmsg)
    //                 this.getList()
    //            }
    //
    //        })
    //        .catch(function (err) {
    //            console.log(err);
    //        });
    // },
    // 获取产品列表
    getList() {
      let data = this.$qs.stringify({
        page_no: this.page_no,
        page_size:this.page_size,
        awards_id: this.itemdata.id,
      });

      nhneProductlists(data)
        .then((res) => {
          if (res.data.code == 1) {
            this.list = res.data.data.lists;
            this.total = Number(res.data.data.count);
            this.list.map((item) => {
              item.imgs = item.imgs;
            });
            // //开始时间戳
            let reg_starttime = this.itemdata.reg_starttime;
            let reg_endtime = this.itemdata.reg_endtime;
            //当前时间戳
            let timestamp = Date.now() / 1000;
            // console.log(timestamp,reg_starttime,"reg_starttime")
            //如果开始时间戳小于当前时间戳 跳转到奖项填写页面 否则弹出提示信息
            if (reg_starttime < timestamp) {
              this.timestatus = 0;
            } else if (reg_endtime < timestamp) {
              this.timestatus = 1;
            } else {
              this.timestatus = 2;
            }
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取评奖数量
    getEnrollCount() {
      let data = this.$qs.stringify({ awards_id: this.itemdata.id });

      getEnrollCount(data)
        .then((res) => {
          if (res.data.code == 1) {
            this.count = res.data.data.count;
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 跳转产品/评奖详情
    getdetail(type, id) {
      this.$router.push({
        name: "productawardDetail",
        query: {
          type: type,
          id: id,
        },
      });
    },
    handleSizeChange(val) {
      this.page_size = val;
      this.page_no = 1; // 切换每页条数时重置当前页为第一页

      this.getList();
    },
    handleCurrentChange(val) {
      this.page_no = val;

      this.getList();
    },
    // 跳转添加&修改页面
    tapForm(type, id, market_time_status) {
      if (type == "add") {
        this.$router.push({
          name: "addproductList",
            query: {
                item: this.itemdata,
            },
        });

        //   window.location.href=`<?= URL('discussion.addproductList','id='); ?>${this.award_id}`
      } else {
        this.$router.push({
          name: "productawardForm",
          query: {
            id: id,
            item: this.itemdata,
          },
        });
        // window.location.href = `<?= URL('discussion.productawardForm'); ?>&id=${this.award_id}&product_id=${id}`;
      }
    },
    // 跳转详情
    tapdetail() {
      window.location.href = "<?= URL('discussion.productawardDetail'); ?>";
    },
    //撤销
    cancle(id) {
      this.$confirm(`撤销后需要重新选择产品参选，是否撤销？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.revokeProduct(id);
        })
        .catch(() => {});
    },
    //撤销产品
    revokeProduct(id) {
      let data = {
        awardsid: this.award_id,
        dataid: id,
      };
      axios
        .post("api.php?m=nhneProduct.revoke_product&v=3.0", qs.stringify(data))
        .then((res) => {
          console.log(res, "---撤销产品");
          if (res.status == 200) {
            if (res.data.errno == "0") {
              this.$message.success(res.data.errmsg);
              setTimeout(() => {
                this.page_no = 1;
                this.getList();
              }, 1000);
            } else {
              this.$message.error(res.data.errmsg);
            }
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    //显示邮寄地址
    showAddress() {
      this.isShowAddress = true;
    },
    //隐藏邮寄地址
    hideAddress() {
      this.isShowAddress = false;
    },
    // 复制地址
    async copyToClipboard() {
      const inputElement = this.$refs.inputElement;
      inputElement.select();
      try {
        await navigator.clipboard.writeText(this.address);
        this.$message.success("复制成功");
      } catch (error) {
        this.$message.error("复制失败，请手动复制");
      }
    },
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>

  .close-btn{
    width: 130px;
    height: 44px;
    color: #666;
    font-size: 14px;
    line-height: 44px;
    text-align: center;
    background: #FFF;
    border-radius: 8px;
    cursor: pointer;
  }
.background1 {
  background-image: url("../../assets/discussion/image_bg1.jpg");
}
.background2 {
  bbackground-image: url("../../assets/discussion/image_bg2.jpg");
}
.modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999999;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
}

button {
  margin: 10px;
}
.tips {
  color: red;
  font-size: 16px;
  margin-left: 15px;
}
.footer_btn {
  display: flex;
  position: absolute;
  bottom: 10px;
  right: 8px;
}
body {
  background: #fff !important;
}
.tipsa{
    color: red;
    // margin-top: 10px;
}
.content {
  background: #fff !important;
  margin-right: 40px !important;
}
/*评奖报名首页*/
.main{
    padding: 30px 0px 30px 40px;
    box-sizing: border-box;
}
.main .title {
  color: #000;
  font-size: 20px;
  font-weight: 500;
  line-height: 30px;
  font-family: SourceHanSansCN, SourceHanSansCN;
}
.main .dis-notice {
  color: #000;
  padding: 20px;
  box-sizing: border-box;
  font-size: 14px;
  line-height: 22px;
  border-radius: 8px;
  background: #f8f8f8;
  margin: 20px 0 52px;
  font-family: PingFangSC, PingFang SC;
}
.main .dis-notice p {
  max-width: 730px;
}
.main .dis-notice .seek {
  font-size: 16px;
  line-height: 24px;
  padding-top: 15px;
}
.main .dis-list .dis-item {
  width: 44%;
  height: 162px;
  max-width: 510px;
  min-width: 430px;
  margin-right: 30px;
  margin-bottom: 30px;
  background: #f6f7fc;
  border-radius: 8px;
  box-sizing: border-box;
  padding: 31px 20px 20px;
  font-size: 14px;
  color: #000;
  line-height: 20px;
  position: relative;
  font-family: PingFangSC, PingFang SC;
}
.main .dis-list .dis-item-left .dis-title {
  font-size: 24px;
  font-weight: 500;
  line-height: 33px;
}
.main .dis-list .dis-item-left .dis-time {
  font-size: 20px;
  padding: 15px 0;
  line-height: 28px;
}
.main .dis-list .dis-item-left .dis-more a {
  color: #999;
  display: flex;
  align-items: center;
}
.main .dis-list .dis-item-left .dis-more .more-img {
  width: 17px;
}
.main .dis-list .dis-item .sign-tips {
  width: 116px;
  height: 39px;
  color: #ff0000;
  font-size: 18px;
  text-align: center;
  line-height: 39px;
  position: absolute;
  top: 0;
  right: 0;
  background: linear-gradient(
    180deg,
    rgba(255, 0, 0, 0) 0%,
    rgba(255, 0, 0, 0.2) 100%
  );
  border-radius: 8px 8px 8px 26px;
}
.main .dis-list .dis-item-right .dis-btn {
  width: 128px;
  height: 44px;
  color: #fff;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  line-height: 44px;
  text-align: center;
  background: #fc9749;
  border-radius: 8px;
  border: 1px solid #fc9749;
  font-family: PingFangSC, PingFang SC;
}
.main .dis-list .dis-item-right .dis-ebtn {
  color: #fc9749;
  background: #fff;
  border: 1px solid #fc9749;
}

/*奖项详情*/
.main-details .details-top {
  height: 78px;
  padding: 0 40px;
  font-size: 18px;
  font-family: SourceHanSansCN, SourceHanSansCN;
  color: #000;
  background: #f3f4f8;
}
.main-details .details-top .close-btn {
  width: 130px;
  height: 44px;
  color: #666;
  font-size: 14px;
  line-height: 44px;
  text-align: center;
  background: #fff;
  border-radius: 8px;
  cursor: pointer;
}
.main-details .details-title {
  color: #3d83e8;
  font-size: 16px;
  padding-top: 20px;
  line-height: 24px;
  margin-left: 40px;
  padding-bottom: 10px;
  font-family: PingFangSC, PingFang SC;
  border-bottom: 1px solid #3d83e9;
}
.main-details .details-content {
  padding: 20px;
  margin: 20px 40px;
  background: #f8f8f8;
  border-radius: 8px;
}

/*品牌企业奖——信息填写*/
.content_main .content-notice {
  padding: 20px;
  font-size: 14px;
  color: #000;
  line-height: 22px;
  min-height: 106px;
  background: #f8f8f8;
  border-radius: 8px;
  margin-right: 38px;
  margin-bottom: 20px;
  box-sizing: border-box;
  font-family: PingFangSC, PingFang SC;
}
.save_btn .el-button {
  width: 130px;
}
/*.demo-ruleForm .el-form-item{*/
/*    padding-right: 30px;*/
/*}*/
/*.demo-ruleForm .el-form-item__label{*/
/*    padding: 0;*/
/*    color: #000;*/
/*    font-size: 16px;*/
/*    line-height: 35px;*/
/*    font-family: PingFangSC, PingFang SC;*/
/*}*/
.awards-upload .el-upload--picture-card,
.awards-upload .el-upload--picture-card .upload-tip,
.awards-upload .el-upload-list--picture-card .el-upload-list__item {
  width: 262px;
  height: 128px;
}
.awards-upload .el-upload--picture-card {
  background: #fff;
}
.awards-upload .el-upload--picture-card .upload-tip i {
  padding-top: 20px;
  display: inline-block;
}
.awards-upload .el-upload--picture-card .upload-tip .upload-img {
  width: 34px;
  height: 34px;
  display: block;
  margin: 0 auto 15px;
}
.awards-upload .el-upload--picture-card .upload-tip .tips {
  width: 100%;
  height: 24px;
  color: #000;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
}
.awards-upload .el-upload-list--picture-card .el-upload-list__item {
  position: relative;
}
.awards-upload .el-upload-list--picture-card .el-upload-list__item-thumbnail {
  height: auto;
  max-width: 100%;
  max-height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.pdf_box {
  width: 358px;
  height: 68px;
  background: #ffffff;
  border-radius: 8px;
  margin-top: 10px;
  display: flex;
  align-items: center;
  padding: 0 15px;
  box-sizing: border-box;
}
.pdf_box img {
  width: 28px;
  height: 28px;
}
.txt_box {
  margin: 0 58px 0 10px;
}
.txt_title {
  width: 173px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 13px;
  color: #000000;
  line-height: 24px;
}
.txt_size {
  width: 39px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #999999;
  line-height: 24px;
}
.xz_btn {
  width: 54px;
  height: 26px;
  line-height: 26px;
  background: #e4efff;
  border-radius: 4px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #3d83e9;
  text-align: center;
  cursor: pointer;
}

.cp_green {
  border-color: #52c41a;
}
.cp_operate {
  width: 20px;
  height: 20px;
  position: absolute;
  bottom: 15px;
  right: 17px;
  z-index: 99;
}
.cp_operate .cp_icon {
  width: 20px;
  height: 20px;
  cursor: pointer;
}
.cp_operate:hover .cp_edit {
  /* opacity: 1; */
  display: block;
}
.cp_edit {
  position: absolute;
  top: 13px;
  left: -45px;
  width: 110px;
  height: 86px;
  /* opacity: 0; */
  display: none;
  padding: 15px 9px 0;
  box-sizing: border-box;
  background: url("../../assets/discussion/dis_bg.png") no-repeat;
  background-size: 100% 100%;
}
.cp_edit .edit-text {
  color: #333;
  font-size: 12px;
  line-height: 30px;
  cursor: pointer;
  text-align: center;
}
.address-wrap {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.4);
}
.address-wrap .address-main {
  width: 563px;
  height: 225px;
  padding: 22px;
  box-sizing: border-box;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0px 12px 48px 16px rgba(0, 0, 0, 0.03),
    0px 9px 28px 0px rgba(0, 0, 0, 0.05), 0px 6px 16px -8px rgba(0, 0, 0, 0.08);
}
.address-wrap .address-main .address-tips {
  font-size: 14px;
  color: #ff4d4f;
  line-height: 20px;
}
.address-wrap .address-main .adress_box {
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #222;
  margin-top: 20px;
}
.address-wrap .address-main .adress_box .adress_input {
  flex: 1;
  margin-right: 20px;
}
.address-wrap .address-main .adress_box .fz_btn {
  font-size: 14px;
  color: #3c81e6;
  margin-right: 20px;
  cursor: pointer;
}
.adress_box .adress_input .el-input__inner {
  font-weight: bold;
  background: #edf1f7;
  border: 0 none;
}
strong {
  font-weight: bold;
}
.end {
  background: #c8cbd3 !important;
  border: 1px solid #c8cbd3 !important;
}
.header_title {
  font-size: 18px;
  font-family: SourceHanSansCN, SourceHanSansCN;
  font-weight: 400;
}
.header_main {
  background: #f3f4f8;
  padding: 30px 38px;
  box-sizing: border-box;
}
.content_main {
  padding: 30px 0 30px 38px;
  box-sizing: border-box;
}
.content_title {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #000000;
}
.btn_box {
  margin: 20px 0 30px;
}
.tb_btn {
  display: inline-block;
  width: 130px;
  height: 44px;
  line-height: 44px;
  background: #3d83e9;
  border-radius: 8px;
  font-size: 14px;
  color: #ffffff;
  text-align: center;
  cursor: pointer;
}
.xj_btn {
  display: inline-block;
  width: 130px;
  height: 44px;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #3d83e9;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #3d83e9;
  line-height: 44px;
  text-align: center;
  margin-left: 15px;
  cursor: pointer;
}
.cp_list {
  display: flex;
  flex-wrap: wrap;
}
.cp_item {
  position: relative;
  width: 500px;
  /*height: 120px;*/
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  margin-right: 30px;
  padding: 15px;
  box-sizing: border-box;
  margin-bottom: 30px;
  display: flex;
}
.cp_item_img {
  width: 90px;
  height: 90px;
}
.cp_item_bottom {
  display: flex;
}
.cp_item_bottom img {
  width: 28px;
  height: 28px;
  margin-left: 52px;
}
.cp_item_bottom span {
  display: inline-block;
  width: 290px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #000000;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-all;
  margin-top: 6px;
}
.cp_item_top {
  display: flex;
  align-items: center;
}
.cp_item_top span:nth-child(1) {
  width: 280px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 20px;
  color: #000000;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all;
}
.tj {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 12px;

  position: absolute;
  right: 17px;

}
.wtj {
  color: #ff4d4f !important;
}
.ytj {
  color: #52c41a !important;
}
.txt_content {
  margin-left: 15px;
  margin-bottom: 30px;
}
.cp_item_icon {
  position: absolute;
  top: 5px;
  left: 5px;
  width: 60px;
  height: 22px;
  line-height: 22px;
  text-align: center;
  border-radius: 12px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #ffffff;
}
.rw_icon {
  background: #ffcc00;
}
.wrw_icon {
  background: #999999;
}
.cypx {
  width: 68px;
  height: 24px;
  line-height: 24px;
  background: #fc9749;
  border-radius: 4px;
  border: 1px solid #fc9749;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #ffffff;
  text-align: center;

  cursor: pointer;
  margin-right: 10px;
}
.el-pagination {
  text-align: right;
  margin-right: 100px;
}
@media only screen and (max-width: 767px) {
  .main{
    width: 96%;
    padding: 5px 0 15px  0px;
  }
  .main .dis-list .dis-item{
    width: 100%;
    min-width: 318px;
    margin-right: 30px;
    margin-bottom: 30px;
    background: #F6F7FC;
    border-radius: 8px;
    padding: 31px 20px 20px;
    box-sizing: border-box;
    font-size: 14px;
    color: #000;
    line-height: 20px;
    position: relative;
    font-family: PingFangSC, PingFang SC;
  }
  .header_main{
    padding: 30px 10px;
}
  .content_main{
    padding: 30px 0 ;
  }
  .cp_item{
    width: 96%;
  }
  .footer_btn{
    right: 8px;
  }
}
</style>